import type { FeedsStatus, TouchFeedRetry } from '@ofmos/shared/feeds';
import type { FeedsClient } from '../client';
import type { Transport } from './transport';

/**
 * `FeedsClient` over `GET /api/feeds/status` (redesign D9), as thin as `HttpHealthClient`: the
 * shape is `feedsStatusSchema` in `@ofmos/shared/feeds`, decided once on the server.
 */
export class HttpFeedsClient implements FeedsClient {
  constructor(private readonly transport: Transport) {}

  status(): Promise<FeedsStatus> {
    return this.transport.request<FeedsStatus>({ method: 'GET', path: '/api/feeds/status' });
  }

  /** "Retry now" (redesign D10): no body, `{ queued: true }` back (`touchFeedRetrySchema`). */
  retryTouch(): Promise<TouchFeedRetry> {
    return this.transport.request<TouchFeedRetry>({
      method: 'POST',
      path: '/api/feeds/touch/run',
    });
  }
}
